import { render } from "./ClientAddressInfo.vue?vue&type=template&id=1d578901"
import script from "./ClientAddressInfo.vue?vue&type=script&lang=js"
export * from "./ClientAddressInfo.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__